import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const VillageColumns = (props) => {
  const activityColumns: any = [
    {
      name: props.t('village_url'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('village_code'),
      selector: (row) => row.code,
      sortable: false,
      center: true,
    },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={activityColumns} data={props.data} />;
};
export default translate(VillageColumns);
